export type FilterObject = { [key: string]: any };

export const reduceFiltersToApi = (filters: FilterObject) => {
  return Object.keys(filters).reduce((acc: FilterObject, filter: string) => {
    if (filters[filter] && filters[filter].length) {
      acc[filter] = filter.includes("After")
        ? new Date(`${filters[filter]}T00:00:00`).toISOString()
        : filter.includes("Before")
        ? new Date(`${filters[filter]}T23:59:59`).toISOString()
        : filters[filter];
    } else if (filters[filter] === true) {
      acc[filter] = filters[filter];
    }
    return acc;
  }, {});
};
